/**
 * @description 国家地理藏品抽奖页接口
*/
import { Toast } from "antd-mobile";
import Services from 'services';
import Library from 'library';
const {JsBridge, Platform, Util} = Library;


class Service {

    /**
     * @description 优先从链接取 userCode，没有再用 JsBridge / 本地缓存
     */
    static resolveUserCode = async () => {
        // 用 URLSearchParams，避免 token 中的 = 导致 paramsToObj 解析异常
        let urlUserCode = '';
        try {
            urlUserCode = new URLSearchParams(window.location.search).get('userCode') || '';
        } catch (e) {
            urlUserCode = Util.url.param('userCode') || '';
        }
        if (urlUserCode) return urlUserCode;

        const userInfo = await JsBridge.getCurrentUserInfo();
        if (userInfo?.loginName || userInfo?.userCode) {
            return userInfo.loginName || userInfo.userCode;
        }

        try {
            const stored = JSON.parse(localStorage.getItem('user_info') || '{}');
            return stored.loginName || stored.userCode || '';
        } catch (e) {
            return '';
        }
    }

    /**
    * @description 初始化接口
    * @interface 600944
    * @param { 是否显示加载loading } showLoading
    *
   */
    static getInitData = async (showLoading = true, data={}) => {
        const code = '600944'
        try {
            const params = {
                ...data,
                userCode: await Service.resolveUserCode()
            }
            const ServiceModule = JsBridge.hasWebViewBridge() ? 'MainPage': 'Common'
            const res = await Services(ServiceModule, { code }, params, !showLoading);
            if (res.status > 0) {
                return { data: res.data?.result || res.data };
            } else {
                throw res.message || '请求失败'
            }
        } catch (error) {
            !JsBridge.hasWebViewBridge() && Toast.show(error || '请求失败')
        }
    }

    /**
     * @description 获取奖品九宫格数据
     * @interface 600114
     * @param { 是否显示加载loading } showLoading
     *
   */
    static fetchGifts = async (showLoading = true, params = {}) => {
        const code = '600114'
        try {
            const ServiceModule = JsBridge.hasWebViewBridge() ? 'MainPage': 'Common'
            const res = await Services(ServiceModule, { code }, params, !showLoading);
            if (res.status > 0) {
                return { data: res.data?.result || res.data };
            } else {
                throw res.message || '请求失败'
            }
        } catch (error) {
            !JsBridge.hasWebViewBridge() && Toast.show(error || '请求失败')
        }
    }

    /**
     * @description 抽奖接口
     * @interface 600864
     * @param {activityCode: 活动编码, reduceTimes: 抽奖次数1或10}
    */
    static lotteryGift = async (params={}) => {
        const code = '600864'
        try {
            const body = {
                ...params,
                userCode: params.userCode || await Service.resolveUserCode()
            }
            const ServiceModule = JsBridge.hasWebViewBridge() ? 'MainPage': 'Common'
            const res = await Services(ServiceModule, { code }, body, true);
            if (res.status > 0) {
                return res;
            }else {
                throw res.message || '请求失败';
            }
        } catch (error) {
            !JsBridge.hasWebViewBridge() && Toast.show(error || '请求失败')
        }
    }

}

export default Service;